export default __webpack_public_path__ + "static/N0154-ddbc2b6c30a2477e7db8e59952e48c84.png";